



































































































































































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';
import MainButton from '@/main-components/common/MainButton.vue';
import Icon from '@/main-components/common/Icon.vue';
import ModalAnswerSheet from '@/main-components/common/modal/ModalAnswerSheet.vue';
import ModalGradePaperSchema from '@/main-components/common/modal/ModalGradePaperSchema.vue';
import ModalGradePaperConfirm from '@/main-components/common/modal/ModalGradePaperConfirm.vue';
import ModalConfirm from '@/main-components/common/modal/ModalConfirm.vue';
import PremiumModal from '@/main-components/premium/PremiumModal.vue';
import LoadingBox from '@/components/common/LoadingBox.vue';
import {
  GradeAnswerSheet,
  GradePaper,
  GradeSchema,
  GradeStatus,
} from '@/resource/grade/grade.model';
import { axios } from '@/utils/axios';
import NotFound from '@/components/common/NotFound.vue';
import { UserStatus } from '@/resource/user/user.model';
import { getUserStatus } from '@/utils/cookie';

@Component({
  components: {
    MainButton,
    Icon,
    ModalAnswerSheet,
    ModalGradePaperSchema,
    ModalGradePaperConfirm,
    ModalConfirm,
    PremiumModal,
    LoadingBox,
    NotFound,
  },
  metaInfo(this: GradePapers): MetaInfo {
    return {
      title: `Auto Grade |`,
      meta: [
        ...seoDefault({
          title: `Auto Grade | Mysoalan`,
          description: '',
        }),
      ],
    };
  },
})
export default class GradePapers extends Vue {
  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorBlackPrimary')
  colorBlackPrimary!: string;

  get gradePaperUuid() {
    return this.$route.params.uuid;
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  isLoading = true;
  answerSheets: GradeAnswerSheet[] = [];
  seletectedAnswerSheet: GradeAnswerSheet | null = null;
  gradePaper: GradePaper | null = null;
  gradeSchema: GradeSchema | null = null;

  openModalAnswerSheet: any = null;
  openModalGradePaperSchema: any = null;
  openModalGradePaperConfirm: any = null;

  openModalAnswerSheetAdd(openModal: any) {
    this.openModalAnswerSheet = openModal;
  }

  openModalGradePaperSchemaAdd(openModal: any) {
    this.openModalGradePaperSchema = openModal;
  }

  openModalGradePaperConfirmAdd(openModal: any) {
    this.openModalGradePaperConfirm = openModal;
  }

  async created() {
    await this.getGradePaper();

    if (this.gradePaper) {
      this.$sendMpEvent({ event: this.$mp_value.AutoGrade_ViewPaper });

      await this.getAnswerSheets();
      await this.getGradeSchema();
    }

    this.isLoading = false;
  }

  async getGradePaper() {
    try {
      const { data } = await axios.get(`/grade-papers/${this.gradePaperUuid}`);

      if (data) {
        this.gradePaper = data as GradePaper;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async refetchPaperAndAnswerSheets() {
    if (this.isLoading) return;
    this.isLoading = true;
    await this.getGradePaper();
    await this.getAnswerSheets();
    this.isLoading = false;
  }

  async getAnswerSheets() {
    try {
      const { data } = await axios.get(
        `/grade-papers/${this.gradePaperUuid}/grade-answer-sheets`,
      );

      if (data) {
        this.answerSheets = data as GradeAnswerSheet[];
      }
    } catch (error) {
      console.log(error);
    }
  }

  async refetchAnswerSheets() {
    if (this.isLoading) return;
    this.isLoading = true;
    await this.getAnswerSheets();
    this.isLoading = false;
  }

  async getGradeSchema() {
    try {
      const { data } = await axios.get(
        `/grade-papers/${this.gradePaperUuid}/grade-schema`,
      );

      if (data) {
        this.gradeSchema = data as GradeSchema;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async refetchSchema() {
    if (this.isLoading) return;
    this.isLoading = true;
    await this.getGradeSchema();
    this.isLoading = false;
  }

  viewAnswerSheet(answerSheet: GradeAnswerSheet | null) {
    if (!answerSheet) {
      this.$sendMpEvent({
        event: this.$mp_value.AutoGrade_ModalAddAnswerSheet,
      });
    }

    this.seletectedAnswerSheet = answerSheet;
    this.openModalAnswerSheet && this.openModalAnswerSheet();
  }

  viewSchema() {
    if (!this.gradeSchema) {
      this.$sendMpEvent({ event: this.$mp_value.AutoGrade_ModalAddSchema });
    }

    this.openModalGradePaperSchema && this.openModalGradePaperSchema();
  }

  autoGradeClicked() {
    if (
      this.gradePaper &&
      (this.gradePaper.status == GradeStatus.InProgress ||
        this.gradePaper.status == GradeStatus.Graded)
    ) {
      if (this.gradePaper.status == GradeStatus.Graded) {
        this.$toasted.global.mainToast({
          message: 'Your paper is already graded.',
        });
      } else {
        this.$toasted.global.mainToast({
          message:
            'Your paper is currently being graded. Thank you for your patience!',
        });
      }
    } else if (this.gradeSchema) {
      if (this.isPremiumStatus) {
        this.$sendMpEvent({ event: this.$mp_value.AutoGrade_ModalStart });
        this.openModalGradePaperConfirm && this.openModalGradePaperConfirm();
      } else {
        this.$sendMpEvent({ event: this.$mp_value.AutoGrade_ModalPremium });
        const modalPremium = this.$refs.modalPremium as any;
        modalPremium.openModalPremium();
      }
    } else {
      this.$toasted.global.mainToast({
        message: 'Please add schema first',
      });
    }
  }

  deleteAnswerSheetClick(answerSheet: GradeAnswerSheet) {
    this.seletectedAnswerSheet = answerSheet;
    const modalDeleteAnswerSheet = this.$refs.modalDeleteAnswerSheet as any;
    modalDeleteAnswerSheet.openModalConfirm();
  }

  async deleteAnswerSheet() {
    try {
      const response = await axios.delete(
        `/grade-papers/${this.gradePaperUuid}/grade-answer-sheets/${this.seletectedAnswerSheet?.id}`,
      );

      if (response) {
        this.$toasted.global.mainToast({
          message: 'Answer sheet successfully deleted.',
        });
        this.refetchAnswerSheets();
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: error,
      });
    }
  }
}
